import {
	Component,
	OnInit,
	ChangeDetectorRef,
	HostListener,
	AfterViewInit,
	ViewChild,
	ChangeDetectionStrategy,
	OnDestroy
} from "@angular/core";
import { Router } from "@angular/router";
import { GlobalService } from "src/app/services/global/global.service";
import { DMVStoreService } from "src/app/services/dmv/dmv-store.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AgencyDmvConfigResponse } from "src/app/models/dmv/agency-config.response";
import { FundingToken } from "src/app/models/dmv/fundingToken";
import { RouteFrom } from "src/app/models/routeFrom";
import { Registration } from "src/app/models/dmv/registration";
import { PaymentDetails } from "src/app/models/dmv/paymentDetails";
import {
	Address,
	ErrorDescriptionModel,
	ErrorLogRequest,
	ErrorRequest,
	TypeIDEnum
} from "src/app/models/dmv/models";
import { AddressChangeModelComponent } from "../../dmv/address-change-model/address-change-model.component";
import { DMVDataService } from "src/app/services/dmv/dmv-data.service";
import { Renewal } from "../../../models/dmv/renewal";
import { AppUtil } from "../../../utils/app.util";
import { USERStoreService } from "src/app/services/user/user-store.service";
import { PaymentDevice } from "src/app/models/user/paymentDevice";
declare const window: any;

@Component({
	selector: "app-payment-details",
	templateUrl: "./payment-details.component.html",
	styleUrls: ["./payment-details.component.css"],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class GsgPaymentDetailsComponent implements OnInit, OnDestroy {
	constructor(
		private router: Router,
		public globalService: GlobalService,
		public dmvStoreService: DMVStoreService,
		public dmvDataService: DMVDataService,
		private formBuilder: FormBuilder,
		public userStoreService: USERStoreService,
		private cd: ChangeDetectorRef
	) {}

	public firstRegistration: Registration = null;
	public paymentUrl: string;
	public agencyConfig: AgencyDmvConfigResponse;
	public isloading: boolean = true;
	public errorMessage: string = "";
	public buttonLabel: string = "Continue";
	public reCallAccess: boolean;
	public fundingToken: string;
	public renewalRequest: Renewal = {};
	public iframeScrollHeight: number = 0;
	public paymentIframeURI: string = "vembed/payment-frame";

	public webComponentLoadTimeStart: number = 0;
	public webComponentLoadTimeEnd: number = 0;

	public webComponentTokenizationTimeStart: number = 0;
	public webComponentTokenizationTimeEnd: number = 0;
	public savedToProfile: boolean = false;
	public submitted = false;
	public saveToProfileForm: FormGroup;
	public reCallCounter: number = 0;
	public isloadingOnSubmit: boolean = false;
	public loaderInterval: any;

	public postErrorLog(request) {
		this.dmvDataService.postErrorLogRequest(request).subscribe(response => {
			if (response) {
				AppUtil.log(
					"PaymentDetailsComponent postErrorLog() ==>  response: ",
					response
				);
			}
		});
	}

	public createErrorRequest(
		inPage: number,
		inType: TypeIDEnum,
		inSource: string,
		inCode: number,
		inText: string
	) {
		const errorRequestData: ErrorLogRequest = {
			agencyID: this.agencyConfig.agencyDmvConfig.agencyID,
			errorDescription: {
				pageID: inPage,
				typeID: inType,
				source: inSource,
				code: inCode,
				text: inText,
				dataField1: this.dmvStoreService.registrationsInCart.accessToken
			},
			sessionID: this.dmvStoreService.sessionID
		};
		return errorRequestData;
	}

	public postError(request) {
		request.errorField4 =
			this.webComponentTokenizationTimeEnd -
			this.webComponentTokenizationTimeStart;
		request.errorField5 = "";
		request.errorID = 1;

		this.dmvDataService
			.postErrorResponse(
				request,
				this.agencyConfig.agencyDmvConfig.agencyID,
				this.dmvStoreService.sessionID
			)
			.subscribe(response => {
				if (response) {
					AppUtil.log(
						"PaymentDetailsComponent getErrorResponse() ==>  response: ",
						response
					);
				}
			});
	}

	public getFundingToken(paymentDetails: PaymentDetails, agencyID) {
		let shortName = null;
		if (
			this.userStoreService.getUserProfile() &&
			this.userStoreService.getUserProfile().megUserGUID &&
			this.savedToProfile
		) {
			shortName = this.saveToProfileForm.controls.shortName.value;
			paymentDetails.fundingToken.addToProfile = true;
			paymentDetails.fundingToken.shortName = shortName;
		}
		AppUtil.log(
			"PaymentDetailsComponent getFundingToken() ==>  PaymentDetails, agencyID",
			paymentDetails,
			agencyID
		);
		const webComponentLoadTime = this.webComponentLoadTimeEnd
			? this.webComponentLoadTimeEnd - this.webComponentLoadTimeStart
			: 0;
		const webComponentTokenizationTime =
			this.webComponentTokenizationTimeEnd -
			this.webComponentTokenizationTimeStart;
		this.dmvDataService
			.getFundingTokenResponse(
				paymentDetails.fundingToken,
				agencyID,
				this.dmvStoreService.sessionID,
				webComponentLoadTime,
				webComponentTokenizationTime
			)
			.subscribe(
				response => {
					AppUtil.log(
						"PaymentDetailsComponent getFundingToken() ==>  response: ",
						response
					);
					if (response) {
						// this.isloading = false;
						this.fundingToken = paymentDetails.fundingToken.fundingToken;
						this.renewalRequest.fundingToken =
							paymentDetails.fundingToken.fundingToken;

						if (
							this.userStoreService.getUserProfile() &&
							this.userStoreService.getUserProfile().megUserGUID
						) {
							this.userStoreService.saveToProfile = this.savedToProfile;
							const userProfile = this.userStoreService.getUserProfile();
							userProfile.paymentDevices = response.userProfile.paymentDevices;
							this.userStoreService.setUserProfile(userProfile);
						} else {
							this.userStoreService.saveToProfile = false;
						}

						this.callRenewApi(
							this.dmvStoreService.registrationsInCart.renewalRequest,
							this.agencyConfig.agencyDmvConfig.agencyID
						);
						this.cd.markForCheck();
					}
				},
				error => {
					AppUtil.log(
						"PaymentDetailsComponent getFundingToken() ==>  error: ",
						error
					);
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.errorMessage =
							this.dmvStoreService.agencyConfig.agencyDmvConfig
								.systemFailureText + "(EC: FT) ";
						this.isloading = false;
						window.scrollTo(0, 0);
						this.cd.markForCheck();
					}
				}
			);
	}

	public callRenewApi(renewalRequest, agencyID) {
		AppUtil.log(
			"PaymentDetailsComponent callRenewApi() ==>  renewalRequest, agencyID: ",
			renewalRequest,
			agencyID
		);
		this.dmvDataService
			.getRenewalResponse(
				renewalRequest,
				agencyID,
				this.dmvStoreService.sessionID
			)
			.subscribe(
				response => {
					if (response) {
						AppUtil.log(
							"PaymentDetailsComponent callRenewApi() ==>  response: ",
							response
						);
						if (response.statusCode !== 200) {
							this.errorMessage =
								this.dmvStoreService.agencyConfig.agencyDmvConfig
									.systemFailureText + " (EC: RNC)";
							this.isloading = false;
							window.scrollTo(0, 0);
							this.cd.markForCheck();
						} else {
							this.dmvStoreService.registrationsInCart.renewalToken =
								response.renewalToken;
							this.getServiceFees();
							this.cd.markForCheck();
						}
					}
				},
				error => {
					AppUtil.log(
						"PaymentDetailsComponent callRenewApi() ==>  error: ",
						error
					);
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.errorMessage =
							this.dmvStoreService.agencyConfig.agencyDmvConfig
								.systemFailureText + " (EC: RNC)";
						this.isloading = false;
						window.scrollTo(0, 0);
						this.cd.markForCheck();
					}
				}
			);
	}
	public get f() {
		return this.saveToProfileForm.controls;
	}
	ngOnInit() {
		AppUtil.log("PaymentDetailsComponent ngOnInit() ==> ");

		this.buttonLabel = "Continue";
		this.dmvStoreService.agencyConfig$
			.subscribe(agencyConfig => {
				if (agencyConfig) {
					this.agencyConfig = agencyConfig;
					this.isloading = true;
					this.callPaymentAccessToken(
						this.dmvStoreService.registrationsInCart.renewalRequest,
						this.agencyConfig.agencyDmvConfig.agencyID
					);
					if (
						this.userStoreService.getUserProfile() &&
						this.userStoreService.getUserProfile().megUserGUID &&
						this.agencyConfig.agencyDmvConfig.reusableFundingToken
					) {
						//	this.savedToProfile = this.userStoreService.saveToProfile;
						this.saveToProfileForm = this.formBuilder.group({
							shortName: ["", [Validators.maxLength(20)]]
						});
					}
				}
			})
			.unsubscribe();

		// if (
		// 	this.userStoreService.getUserProfile() &&
		// 	this.userStoreService.getUserProfile().megUserGUID &&
		// 	this.agencyConfig.agencyDmvConfig.reusableFundingToken
		// ) {
		// 	//	this.savedToProfile = this.userStoreService.saveToProfile;
		// 	this.saveToProfileForm = this.formBuilder.group({
		// 		shortName: ["", [Validators.maxLength(20)]]
		// 	});
		// }
		// this.loaderInterval = setInterval(() => {
		// 	if (
		// 		!(
		// 			document.getElementById("submit-button") &&
		// 			document
		// 				.getElementById("submit-button")
		// 				.classList.contains("disabled")
		// 		)
		// 	) {
		// 		this.isloading = false;
		// 		this.isloadingOnSubmit = false;
		// 		this.cd.detectChanges();
		// 	} else {
		// 		this.isloading = true;
		// 	}
		// }, 200);
	}

	public initiatePaymentComponent() {
		AppUtil.log("PaymentDetailsComponent initiatePaymentComponent() ==> ");
		const webComponetURL = this.agencyConfig.agencyDmvConfig.providerWebCompURL;
		// let isFound = false;
		// const scripts = document.getElementsByTagName("script");
		// for (let i = 0; i < scripts.length; ++i) {
		// 	if (
		// 		scripts[i].getAttribute("src") != null &&
		// 		scripts[i].getAttribute("src").includes("e-wallet.js")
		// 	) {
		// 		isFound = true;
		// 	}
		// }
		const style = document.createElement("link");
		style.type = "text/css";
		style.rel = "stylesheet";
		style.id = "e-walletCSS";
		style.href = webComponetURL + "dist/current/e-wallet.css";
		if (!document.getElementById("e-walletCSS")) {
			document.getElementsByTagName("head")[0].appendChild(style);
		}

		// const script = document.createElement("script");
		// script.type = "text/javascript";
		// script.src = webComponetURL + "dist/current/e-wallet.js";

		// if (!isFound) {
		// 	this.isloading = true;
		// 	document.getElementsByTagName("head")[0].appendChild(script);
		// } else {
		this.isloading = false;
		this.bindEwallet();
		this.cd.markForCheck();
		// }
		// script.onload = () => {
		// 	this.isloading = false;
		// 	this.bindEwallet();
		// 	this.cd.markForCheck();
		// };
		// script.onerror = error => {
		// 	this.isloading = false;
		// 	this.cd.markForCheck();
		// };

		AppUtil.log("PaymentDetailsComponent initiatePaymentComponent() ==> ");
	}

	public bindEwallet() {
		if (
			this.dmvStoreService.registrationsInCart.dmvRegistrations &&
			this.dmvStoreService.registrationsInCart.dmvRegistrations.length > 0
		) {
			this.firstRegistration = this.dmvStoreService.registrationsInCart.dmvRegistrations[0].registration;
		}
		const userProfile = this.userStoreService.getUserProfile();
		let data: PaymentDevice = {};
		if (userProfile && userProfile.contactInfo) {
			data = {
				emailAddress: userProfile.contactInfo.emailAddress,
				phone: userProfile.contactInfo.phoneNumber
			};
		}
		if (this.dmvStoreService.paymentDetails) {
			this.updatePaymenetDetails(data);
		}
		this.populatePaymenetDetails(data);

		const _this = this;
		window.eWallet.attach("#e-wallet", {
			allowedMethods: this.getPaymentMethod(),
			jwt: this.dmvStoreService.registrationsInCart.accessToken,
			textOverrides: {
				submit_button: {
					en: "Continue"
				}
			},
			extraFields: {
				email: {
					required: true,
					initialValue: this.dmvStoreService.paymentDetails.fundingToken
						.billingEmailAddress,
					showForSavedTenders: true
				},
				phone: {
					required: true,
					initialValue: this.dmvStoreService.paymentDetails.fundingToken
						.billingPhone,
					showForSavedTenders: true
				}
			},
			refreshJwt: function(callbackRefresh) {
				console.log("invalidTken : Current Path" + _this.router.url);

				if (_this.router.routerState.snapshot.url === "/gsg-payment") {
					_this.callPaymentAccessToken(
						_this.dmvStoreService.registrationsInCart.renewalRequest,
						_this.agencyConfig.agencyDmvConfig.agencyID,
						false,
						callbackRefresh
					);
				}
			},
			onSubmit: function(tender) {
				console.log("User checked out with tender: ", tender);
				_this.isloading = true;
				_this.cd.markForCheck();
				_this.continue(tender);
				// In real life, you'd need further UI interactions and
				// API calls to submit the payment. But for the sake of
				// the example, we'll just show a dummy confirmation page.
			}
		});
	}
	public getPaymentMethod() {
		const paymentethodsList = [];
		if (this.agencyConfig.agencyDmvConfig.paymentMethods) {
			this.agencyConfig.agencyDmvConfig.paymentMethods.forEach(methods => {
				if (methods.name) {
					paymentethodsList.push(methods.name);
				}
			});
		}

		// If payment method is not returned, set the default to card
		if (paymentethodsList.length === 0) {
			paymentethodsList.push("card");
		}

		return paymentethodsList;
	}
	public updatePaymenetDetails(data: PaymentDevice) {
		if (this.dmvStoreService.paymentDetails.fundingToken && data) {
			this.dmvStoreService.paymentDetails.fundingToken.billingPhone =
				data.phone;
		}
		if (this.dmvStoreService.paymentDetails.fundingToken && data) {
			this.dmvStoreService.paymentDetails.fundingToken.billingEmailAddress =
				data.emailAddress;
		} else if (
			!this.dmvStoreService.paymentDetails.fundingToken &&
			this.globalService.supportKioskPickup
		) {
			this.dmvStoreService.paymentDetails.fundingToken.billingEmailAddress = this.dmvStoreService.registrationsInCart.pickupInPerson.email;
		}
	}

	public goBack() {
		AppUtil.log("PaymentDetailsComponent goBack() ==>");
		const _this = this;
		if (
			this.userStoreService.getUserProfile() &&
			this.userStoreService.getUserProfile().megUserGUID &&
			this.userStoreService.getUserProfile().paymentDevices &&
			this.userStoreService.getUserProfile().paymentDevices.length > 0 &&
			this.userStoreService
				.getUserProfile()
				.paymentDevices.filter(function(item) {
					return (
						Number(_this.dmvStoreService.selectedAgencyId) === item.agencyID
					);
				}).length > 0
		) {
			this.router.navigate(["select-payment-method"], {
				skipLocationChange: true
			});
		} else {
			const routeFrom: RouteFrom = Object.create(null);
			this.dmvStoreService.routeFrom = routeFrom;
			this.dmvStoreService.routeFrom.from = "payment";
			this.router.navigate(["dmv-review-cart"], { skipLocationChange: true });
		}
	}
	public save() {
		this.errorMessage = "";
		this.submitted = true;
		if (
			this.userStoreService.getUserProfile() &&
			this.userStoreService.getUserProfile().megUserGUID &&
			this.saveToProfileForm &&
			this.saveToProfileForm.invalid
		) {
			this.errorMessage = "Please correct fields in error.";
			console.log("saveToProfileForm.invalid");
			return;
		}

		document.getElementById("submit-button").click();
		this.isloadingOnSubmit = true;
		this.isloading = true;
		// this.continue();
	}

	public continue(messageData: any) {
		AppUtil.log("PaymentDetailsComponent continue() ==>");
		this.errorMessage = "";

		this.isloading = true;
		this.cd.markForCheck();
		this.updatedPaymenetDetails(messageData);
		this.dmvStoreService.registrationsInCart.renewalRequest.fundingToken = this.dmvStoreService.paymentDetails.fundingToken.fundingToken;
		this.getFundingToken(
			this.dmvStoreService.paymentDetails,
			this.agencyConfig.agencyDmvConfig.agencyID
		);
	}

	public callPaymentAccessToken(
		renewalRequest,
		agencyID,
		refrsh?: boolean,
		callbackRefresh?
	) {
		AppUtil.log(
			"PaymentDetailsComponent callPaymentAccessToken() ==> renewalRequest, agencyID :",
			renewalRequest,
			agencyID
		);
		this.dmvDataService
			.getPaymentAccessTokenResponse(agencyID, this.dmvStoreService.sessionID)
			.subscribe(
				response => {
					AppUtil.log(
						"PaymentDetailsComponent callPaymentAccessToken() ==> response :",
						response
					);
					if (response) {
						if (response.accessToken) {
							this.webComponentLoadTimeStart = new Date().getTime();
							this.dmvStoreService.registrationsInCart.accessToken =
								response.accessToken;
							if (!refrsh) {
								this.initiatePaymentComponent();
								this.cd.markForCheck();
							}
							if (refrsh) {
								callbackRefresh(
									this.dmvStoreService.registrationsInCart.accessToken
								);
							}
						} else {
							this.errorMessage =
								this.dmvStoreService.agencyConfig.agencyDmvConfig
									.systemFailureText + " (EC:AT)";

							window.scrollTo(0, 0);
							this.isloading = false;
							this.buttonLabel = "Try Again";
							this.reCallAccess = true;
							this.cd.markForCheck();
						}
					}
				},
				error => {
					AppUtil.log(
						"PaymentDetailsComponent callPaymentAccessToken() ==> error :",
						error
					);
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.errorMessage =
							this.dmvStoreService.agencyConfig.agencyDmvConfig
								.systemFailureText + " (EC:AT)";
						this.isloading = false;
						window.scrollTo(0, 0);
						this.buttonLabel = "Try Again";
						this.reCallAccess = true;
						this.cd.markForCheck();
					}
				}
			);
	}

	private populatePaymenetDetails(data: PaymentDevice) {
		AppUtil.log("PaymentDetailsComponent populatePaymenetDetails() ==> ");
		const paymentDetails: PaymentDetails = new Object({});
		const fundingToken: FundingToken = new Object({});
		fundingToken.billingAddress = new Object({});

		//const firstName = this.firstRegistration.registrantName;
		if (data && data.phone) {
			fundingToken.billingPhone = data.phone;
		}
		if (data && data.emailAddress) {
			fundingToken.billingEmailAddress = data.emailAddress;
		}

		let addressLine1 = this.firstRegistration.registrantAddress
			? this.firstRegistration.registrantAddress.line1
			: "";
		if (addressLine1) {
			addressLine1 = addressLine1.trim();
			fundingToken.billingAddress.line1 = addressLine1;
		}

		let addressLine2 = this.firstRegistration.registrantAddress
			? this.firstRegistration.registrantAddress.line2
			: "";
		if (addressLine2) {
			addressLine2 = addressLine2.trim();
			fundingToken.billingAddress.line2 = addressLine2;
		}

		const stateCode = this.firstRegistration.registrantAddress
			? this.firstRegistration.registrantAddress.stateCode
			: "";
		if (stateCode) {
			fundingToken.billingAddress.stateCode = stateCode;
		}

		const postalCode = this.firstRegistration.registrantAddress
			? this.firstRegistration.registrantAddress.postalCode
			: "";
		if (postalCode) {
			//postalCode = postalCode.substring(0, 5);
			fundingToken.billingAddress.postalCode = postalCode;
		}

		const city = this.firstRegistration.registrantAddress
			? this.firstRegistration.registrantAddress.city
			: "";
		if (city) {
			fundingToken.billingAddress.city = city;
		}

		const countryCode = this.firstRegistration.registrantAddress
			? this.firstRegistration.registrantAddress.countryCode
			: "";
		if (countryCode) {
			fundingToken.billingAddress.countryCode = countryCode;
		}

		if (countryCode !== "US" && stateCode) {
			fundingToken.billingAddress.nonUsRegion = stateCode;
		}

		paymentDetails.fundingToken = fundingToken;
		this.dmvStoreService.paymentDetails = paymentDetails;
		AppUtil.log(
			"PaymentDetailsComponent populatePaymenetDetails() ==> paymentDetails: ",
			paymentDetails
		);
	}

	private updatedPaymenetDetails(data: any) {
		AppUtil.log(
			"PaymentDetailsComponent updatedPaymenetDetails() ==> data: ",
			data
		);
		const paymentDetails: PaymentDetails = new Object({});
		const fundingToken: FundingToken = new Object({});
		fundingToken.billingAddress = new Object({});
		let name = [];
		if (data.tender.userName) {
			name = data.tender.userName.trim().split(" ");
		}

		if (name[0]) {
			fundingToken.billingFirstName = name[0];
		}

		if (name.length > 1) {
			fundingToken.billingLastName = name[name.length - 1];
		}

		let addressLine1 = data.tender.billingAddress.address1;
		if (addressLine1) {
			addressLine1 = addressLine1.trim();
			fundingToken.billingAddress.line1 = addressLine1;
		}

		let addressLine2 = data.tender.billingAddress.address2;
		if (addressLine2) {
			addressLine2 = addressLine2.trim();
			fundingToken.billingAddress.line2 = addressLine2;
		}

		if (
			data.tender.billingAddress.country !== "US" &&
			data.tender.billingAddress.state
		) {
			const nonUsRegion = data.tender.billingAddress.state;
			if (nonUsRegion) {
				fundingToken.billingAddress.nonUsRegion = nonUsRegion;
			}
		} else {
			const stateCode = data.tender.billingAddress.state;
			if (stateCode) {
				fundingToken.billingAddress.stateCode = stateCode;
			}
		}

		const postalCode = data.tender.billingAddress.postalCode;
		if (postalCode) {
			//postalCode = postalCode.substring(0, 5);
			fundingToken.billingAddress.postalCode = postalCode;
		}
		const expiration = data.tender.cardExpiration;
		if (postalCode) {
			//postalCode = postalCode.substring(0, 5);
			fundingToken.expiration = expiration;
		}

		const city = data.tender.billingAddress.city;
		if (city) {
			fundingToken.billingAddress.city = city;
		}

		const country = data.tender.billingAddress.country;
		if (country) {
			fundingToken.billingAddress.countryCode = country;
		}

		const last4 = data.tender.lastDigits ? data.tender.lastDigits : "";
		if (last4) {
			fundingToken.accountLast4 = last4;
		}

		const nameOnAccount = data.tender.userName;
		if (nameOnAccount) {
			fundingToken.nameOnAccount = nameOnAccount;
		}

		const phone = data.extraFields.phone;
		if (phone) {
			fundingToken.billingPhone = phone;
		}

		const emailAddress = data.extraFields.email;
		if (emailAddress) {
			fundingToken.billingEmailAddress = emailAddress;
		}

		const paymentMethod = data.tender.type;
		if (paymentMethod) {
			fundingToken.paymentMethod = paymentMethod;
		}

		const cardBrand = data.tender.cardBrand;
		if (cardBrand) {
			fundingToken.cardBrand = cardBrand;
		} else {
			if (paymentMethod === "Electronic Check") {
				fundingToken.cardBrand = "EC";
			}
		}

		const token = data.tender.ewalletToken;
		if (token) {
			fundingToken.fundingToken = token;
		}
		const nickname = data.tender.nickname;
		if (token) {
			fundingToken.shortName = nickname;
		}

		paymentDetails.fundingToken = fundingToken;
		this.dmvStoreService.paymentDetails = paymentDetails;
		AppUtil.log(
			"PaymentDetailsComponent updatedPaymenetDetails() ==> paymentDetails: ",
			paymentDetails
		);
	}

	public getServiceFees() {
		AppUtil.log("PaymentDetailsComponent getServiceFees() ==>");
		const renewalToken = this.dmvStoreService.registrationsInCart.renewalToken;
		const agencyID = this.agencyConfig.agencyDmvConfig.agencyID;
		this.dmvDataService
			.getServiceFeesResponse(
				renewalToken,
				agencyID,
				this.dmvStoreService.sessionID
			)
			.subscribe(
				response => {
					AppUtil.log(
						"PaymentDetailsComponent getServiceFees() ==> response",
						response
					);
					if (response) {
						this.isloading = false;
						this.cd.markForCheck();
						this.dmvStoreService.registrationsInCart.serviceFeeAmount =
							response.serviceFeeAmount;

						this.router.navigate(["dmv-review-cart-with-billing"], {
							skipLocationChange: true
						});
					}
				},
				error => {
					AppUtil.log(
						"PaymentDetailsComponent getServiceFees() ==> error",
						error
					);
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.errorMessage =
							this.dmvStoreService.agencyConfig.agencyDmvConfig
								.systemFailureText + " (EC: FEE)";
						this.isloading = false;
						this.cd.markForCheck();
						window.scroll(0, 0);
					}
				}
			);
	}

	public getDetailToSaveInProfile(data: PaymentDetails) {
		const obj: PaymentDevice = Object.assign({});
		obj.agencyID = Number(this.agencyConfig.agencyDmvConfig.agencyID);
		obj.cardBrand = data.fundingToken.cardBrand;
		obj.emailAddress = data.fundingToken.billingEmailAddress;
		obj.firstName = data.fundingToken.billingFirstName;
		obj.lastName = data.fundingToken.billingLastName;
		obj.fundingToken = data.fundingToken.fundingToken;
		obj.nameOnAccount = data.fundingToken.nameOnAccount;
		obj.paymentMethod = data.fundingToken.paymentMethod;
		obj.phone = data.fundingToken.billingPhone;
		obj.shortName = data.fundingToken.shortName;

		let type;
		if (data.fundingToken.cardBrand === "VI") {
			type = "Visa";
		}
		switch (data.fundingToken.cardBrand) {
			case "VI": {
				type = "Visa";
				break;
			}
			case "MC": {
				type = "MasterCard";
				break;
			}
			case "AE": {
				type = "AmericanExpress";
				break;
			}
			case "DI": {
				type = "Discover";
				break;
			}
			default:
		}
		obj.type = type;
		obj.accountLast4 = data.fundingToken.accountLast4;
		obj.address = data.fundingToken.billingAddress;

		return obj;
	}

	private getErrorMessage(outcomeCode: string, outcomeText: string): string {
		let errorMessage: string = "";
		switch (outcomeCode) {
			case "1": {
				errorMessage =
					"Please correct all errors indicated below before continuing.";
				break;
			}
			default:
				errorMessage = outcomeText;
		}
		return errorMessage;
	}

	public savedToProfileChange(event) {
		AppUtil.log("PaymentDetailsComponent savedToProfileChange() ==>");
		this.savedToProfile = event.target.checked;
	}

	public ngOnDestroy() {
		if (this.loaderInterval) {
			clearInterval(this.loaderInterval);
		}
	}
}
